import { render } from "./ThumbnailPlaceholders.vue?vue&type=template&id=5577d676&scoped=true"
import script from "./ThumbnailPlaceholders.vue?vue&type=script&lang=js"
export * from "./ThumbnailPlaceholders.vue?vue&type=script&lang=js"

import "./ThumbnailPlaceholders.vue?vue&type=style&index=0&id=5577d676&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5577d676"]])

export default __exports__